const STORAGE_KEY = 'predictit-bank-transfer-intent-v1';
const TOKEN_PATTERN = /^[a-f0-9-]{32,36}$/i;

function normalizeOwner(owner) {
  return typeof owner === 'string' ? owner.trim().toLowerCase() : '';
}

function read(owner) {
  try {
    const value = JSON.parse(sessionStorage.getItem(`${STORAGE_KEY}:${normalizeOwner(owner)}`) || 'null');
    if (!value || !normalizeOwner(owner) ||
      value.owner !== normalizeOwner(owner) ||
      !TOKEN_PATTERN.test(value.submissionToken || '') ||
      !Number.isFinite(value.linkedBankAccountId) || !(value.linkedBankAccountId > 0) ||
      !Number.isFinite(value.amount) || !(value.amount > 0)) return null;
    return value;
  } catch (error) {
    return null;
  }
}

function save(owner, payload) {
  if (!normalizeOwner(owner) || !TOKEN_PATTERN.test(payload.submissionToken || '') ||
    !Number.isFinite(Number(payload.linkedBankAccountId)) ||
    !(Number(payload.linkedBankAccountId) > 0) ||
    !Number.isFinite(Number(payload.amount)) || !(Number(payload.amount) > 0)) {
    throw new Error('The deposit recovery reference could not be saved. Please sign in again.');
  }
  const value = {
    owner: normalizeOwner(owner),
    submissionToken: payload.submissionToken,
    linkedBankAccountId: Number(payload.linkedBankAccountId),
    amount: Number(payload.amount),
  };
  // Save before sending: navigation or a lost HTTP response must not lose the intent.
  sessionStorage.setItem(`${STORAGE_KEY}:${value.owner}`, JSON.stringify(value));
  return value;
}

function clear(owner, submissionToken) {
  const value = read(owner);
  if (value && value.submissionToken === submissionToken) {
    sessionStorage.removeItem(`${STORAGE_KEY}:${value.owner}`);
  }
}

function isDefinitiveFailure(data) {
  const reason = Number(data && data.failureReason);
  return data && data.success === false && Number.isInteger(reason) &&
    reason >= 1 && reason <= 21 && reason !== 11 && reason !== 16;
}

function isUnconfirmedReason(data) {
  const reason = Number(data && data.failureReason);
  return reason === 11 || reason === 16;
}

// Any definite HTTP response below 500 that does not report an unconfirmed submission
// (validation, permission, declined assessment) means no transfer was sent.
function isDefinitiveFailureResponse(response) {
  if (!response) return false;
  if (isDefinitiveFailure(response.data)) return true;
  const status = Number(response.status);
  return status > 0 && status < 500 && !isUnconfirmedReason(response.data);
}

export default { read, save, clear, isDefinitiveFailure, isDefinitiveFailureResponse };



// WEBPACK FOOTER //
// ./src/helpers/bankTransferIntent.js